// E-Ticaret › Blog Ayarları kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.blog';

export const ecommerceBlogGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Blog nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizin blog sayfasını ve blog yazılarınızı burada yönetirsiniz; isterseniz son yazılarınızı ana sayfada bir kart bölümü olarak da gösterebilirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Blog'),
    tabs: t(`${G}.regions.tabs`, 'Blog Sayfası / Anasayfa Kartı'),
    body: t(`${G}.regions.body`, 'Sekme içeriği'),
    footer: t(`${G}.regions.footer`, 'Yazı penceresi: İptal / Kaydet'),
  },
  navItems: [
    t(`${G}.nav.page`, 'Blog Sayfası'),
    t(`${G}.nav.homeCard`, 'Anasayfa Kartı'),
  ],
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Sekmeler ve kaydetme'),
      text: t(`${G}.s1.text`, '"Blog Sayfası" sekmesinde blog sayfasının üst bölümünü, kart listesini ve yazıları; "Anasayfa Kartı" sekmesinde ana sayfadaki blog bölümünü ayarlarsınız. Sayfa ve kart ayarlarında yaptığınız değişiklikler bir an sonra kendiliğinden kaydedilir; yazılar ise yazı penceresindeki "Kaydet" ile kaydedilir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Bölüm başlığı ve kart listesi'),
      text: t(`${G}.s2.text`, '"Sayfa Hero Ayarları" blog sayfasının en üstündeki başlık / görsel alanıdır. "Kart Listesi" bölümünde bir satırda kaç kart (2, 3 veya 4) görüneceğini seçin; "Arama kutusu" ve "Kategori filtresi" açıkken bunlar blog sayfasında kartların hemen üstünde görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Yazı ekleyin'),
      text: t(`${G}.s3.text`, '"Blog Yazıları" bölümündeki "Yeni Yazı Ekle" yazı penceresini açar. Başlık zorunludur; Slug boş bırakılırsa otomatik oluşturulur. "Kategori / Üst Etiket", "Rozet", "Özet / Kart Açıklaması", "İçerik (HTML destekler)" ve "Kapak Görseli" (en çok 8 MB) alanlarını doldurun. "Yayınla" kapalı yazı Taslak olarak kalır; "Sıra" alanına yazının sıra numarasını yazın.'),
      tips: [
        t(`${G}.s3.tip1`, '"Ek Bilgiler" bölümünde "Satır Ekle" ile istediğiniz etiket-değer çiftini ekleyin (ör. "Hazırlık → 20 Dk", "Kapasite → 500 ton/gün").'),
        t(`${G}.s3.tip2`, '"Madde Listesi"ne her satıra bir madde yazın; maddeler kartta ve yazı sayfasında "Liste Başlığı" altında gösterilir.'),
        t(`${G}.s3.tip3`, 'Kalem simgesi yazıyı düzenler. Çöp kutusu simgesi yazıyı onay sormadan hemen siler.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Anasayfa kartı ve konumu'),
      text: t(`${G}.s4.text`, '"Anasayfa Kartı" sekmesinde "Anasayfada Göster" anahtarını açın; Üst Etiket, Bölüm Başlığı ve Bölüm Açıklaması yazın. Bölümün yerini "Hangi bölümün yanında" (Slider, Güven şeridi, Kategoriler, ana sayfa modülleriniz veya Sayfa sonu) ve "Konum" (Bu bölümden önce / sonra) ile seçin; blog kartı seçilen bölümün hemen önünde veya ardından gösterilir.'),
      tips: [
        t(`${G}.s4.tip1`, '"Öne Çıkan Yazı" (Medya Arşivi\'nde "İlk kart") boş bırakılırsa en yeni yazı otomatik kullanılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Kart düzeni'),
      text: t(`${G}.s5.text`, '"Kart şablonu"ndan "Öne Çıkan Kart" (büyük öne çıkan yazı ve altında küçük kartlar) veya "Medya Arşivi"ni (başlık solda, açıklama sağda, eşit video kartları) seçin; "Önizleme" sonucu hemen gösterir. Küçük kart / kart sayısı (2, 3 veya 4), vurgu ve başlık rengi, başlık boyutu, zemin rengi, buton metinleri ve "Kart şekli" (Köşeli, Yuvarlatılmış, Yumuşak) buradan ayarlanır.'),
      tips: [
        t(`${G}.s5.tip1`, 'Medya Arşivi\'nde rozet, görselin üstündeki kanal adıdır. Süre için bir ek bilgi değerine 04:15 gibi bir zaman yazın. Kategoriyi virgül veya • ile ayırırsanız kartta iki etiket görünür. Kart görseli yazının kapak fotoğrafıdır.'),
        t(`${G}.s5.tip2`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
